
import React from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useAuth } from "@/hooks/useAuth";
import { useInternalAuth } from "@/hooks/useInternalAuth";
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import MobileHeader from '@/components/mobile/MobileHeader';
import MobileBottomNav from '@/components/mobile/MobileBottomNav';
import { useIsMobile } from '@/hooks/use-mobile';
import ChatInterface from '@/components/chat/ChatInterface';

const Chat = () => {
  const { groupId } = useParams();
  const [searchParams] = useSearchParams();
  const messageId = searchParams.get('messageId');
  const { user } = useAuth();
  const { user: internalUser } = useInternalAuth();
  const isMobile = useIsMobile();

  const isAuthenticated = !!(user || internalUser);

  if (!isAuthenticated) {
    return (
      <div className="flex flex-col min-h-screen bg-black w-full">
        {!isMobile && <Header />}
        {isMobile && <MobileHeader />}
        
        <main className={`flex-grow w-full ${
          isMobile 
            ? 'pt-16 mb-16 py-6 px-4' 
            : 'mt-24 mb-6 py-6 md:py-12 px-4 md:px-6'
        }`}>
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-3xl font-bold text-white mb-4">Lockeroom</h1>
            <p className="text-gray-400 mb-8">Please log in to access the Lockeroom feature.</p>
          </div>
        </main>
        
        {!isMobile && <Footer />}
        {isMobile && <MobileBottomNav />}
      </div>
    );
  }

  return (
    <div className="flex flex-col min-h-screen bg-black w-full">
      {!isMobile && <Header />}
      {isMobile && <MobileHeader />}
      
      <main className={`flex-grow w-full ${
        isMobile 
          ? 'pt-16 mb-16' 
          : 'mt-24 mb-6'
      }`}>
        <div className="h-full">
          <ChatInterface initialGroupId={groupId} highlightMessageId={messageId || undefined} />
        </div>
      </main>
      
      {!isMobile && <Footer />}
      {isMobile && <MobileBottomNav />}
    </div>
  );
};

export default Chat;
